import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import axios from "../../utils/api.js";

const CelebrityHome = () => {
  const [formData, setFormData] = useState({
    homeInfo: {
      celebrityName: "",
      homeType: "",
      totalFloorArea: 0,
      totalFloors: 0,
      totalRooms: 0,
      luxuryCertifications: "",
    },
    dataCollection: {
      dateOfDataCollection: "",
      dataCollectedBy: "",
      dataSource: "",
    },
    homeLayout: {
      bedrooms: 0,
      bathrooms: 0,
      guestSuites: 0,
      cinemaRoom: false,
      privateGym: false,
      indoorSpa: false,
      homeOffice: false,
      gameRoom: false,
      wineCellar: false,
      walkInClosetCount: 0,
      outdoorSpaces: "",
    },
    cleaningDisinfect: {
      totalBudgetPerMonth: 0,
      cleaningCostbedrooms: 0,
      cleaningCostcommonAreas: 0,
      cleaningCostgymSpa: 0,
      cleaningCostentertainmentAreas: 0,
      cleaningCostkitchen: 0,
      currentDisinfectionMethods: [],
      disinfectionFrequencyPerRoomPerDay: 0,
      challenges: [],
    },
    privacySecurity: {
      privacyConcernLevel: "",
      securityClearanceRequired: false,
      restrictedAreas: [],
      aiAutomationPrivacyConcerns: false,
      customSecurityIntegrationNeeds: [],
    },
    staffAutomation: {
      numberOfHousekeepingStaff: 0,
      cleaningStaffShiftHours: [],
      housekeepingServiceType: "",
      interestInAutomatedDisinfection: false,
      customizationNeedsForScheduling: [],
      integrationWithSmartHomeSystem: false,
      concernsAboutUVCUsage: false,
    },
    smartHome: {
      existingSmartHomeSystem: false,
      preferredBrands: [],
      integrationNeeds: "",
    },
    demoNextSteps: {
      interestInOnSiteDemo: false,
      pilotProjectReadiness: false,
      keyDecisionMaker: "",
      expectedTimelineForDecisionMaking: [],
    },
    additionalnotes: {
      note: "",
    },
  });
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);

  const FORM_STEPS = [
    "Home Info",
    "Data Collection",
    "Home Layout",
    "Cleaning and Disinfect",
    "Privacy and Security",
    "Staff and Automation",
    "Smart Home",
    "Demo and Next Steps",
    "Additional Notes",
  ];
  const totalSteps = FORM_STEPS.length;

  const pageStyle = {
    position: "relative",
    minHeight: "100vh",
    background:
      "radial-gradient(1200px 600px at 10% 0%, rgba(37, 99, 235, 0.10), rgba(255,255,255,0) 60%), radial-gradient(900px 450px at 90% 15%, rgba(16, 185, 129, 0.10), rgba(255,255,255,0) 55%), #ffffff",
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    padding: "24px 32px 48px",
    boxSizing: "border-box",
  };
  const cardStyle = {
    maxWidth: 720,
    margin: "0 auto 24px",
    backgroundColor: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: 14,
    padding: 28,
    boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  };
  const inputGroupStyle = { marginBottom: 18 };
  const labelStyle = {
    display: "block",
    marginBottom: 6,
    fontWeight: 600,
    fontSize: "0.9rem",
    color: "#64748b",
  };
  const inputStyle = {
    width: "100%",
    padding: "0.65rem 0.85rem",
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    fontSize: "1rem",
    outline: "none",
    boxSizing: "border-box",
  };
  const sectionTitleStyle = {
    margin: "0 0 20px",
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "#1e293b",
  };

  const handleChange = useCallback((e, section, nestedSection) => {
    const { name, value, type, checked } = e.target;
    let newValue = value;

    if (type === "number") {
      newValue = Math.max(0, Number(value)) || 0;
    } else if (type === "checkbox") {
      newValue = checked;
    }

    setFormData((prevData) => ({
      ...prevData,
      [section]: nestedSection
        ? {
            ...prevData[section],
            [nestedSection]: {
              ...prevData[section][nestedSection],
              [name]: newValue,
            },
          }
        : {
            ...prevData[section],
            [name]: newValue,
          },
    }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");

      const response = await axios.post("/post-celebrity-home", formData, {
        headers: {
          Authorization: `Bearer ${token}`, // Add auth token
          "Content-Type": "application/json",
        },
      });

      console.log("Data posted successfully:", response.data);
      alert("Home data submitted successfully!");
      navigate("/CelebrityHome");
      // Reset form after successful submission
      setFormData({
        homeInfo: {
          celebrityName: "",
          homeType: "",
          totalFloorArea: 0,
          totalFloors: 0,
          totalRooms: 0,
          luxuryCertifications: "",
        },
        dataCollection: {
          dateOfDataCollection: "",
          dataCollectedBy: "",
          dataSource: "",
        },
        homeLayout: {
          bedrooms: 0,
          bathrooms: 0,
          guestSuites: 0,
          cinemaRoom: false,
          privateGym: false,
          indoorSpa: false,
          homeOffice: false,
          gameRoom: false,
          wineCellar: false,
          walkInClosetCount: 0,
          outdoorSpaces: "",
        },
        cleaningDisinfect: {
          totalBudgetPerMonth: 0,
          cleaningCostbedrooms: 0,
          cleaningCostcommonAreas: 0,
          cleaningCostgymSpa: 0,
          cleaningCostentertainmentAreas: 0,
          cleaningCostkitchen: 0,
          currentDisinfectionMethods: [],
          disinfectionFrequencyPerRoomPerDay: 0,
          challenges: [],
        },
        privacySecurity: {
          privacyConcernLevel: "",
          securityClearanceRequired: false,
          restrictedAreas: [],
          aiAutomationPrivacyConcerns: false,
          customSecurityIntegrationNeeds: [],
        },
        staffAutomation: {
          numberOfHousekeepingStaff: 0,
          cleaningStaffShiftHours: [],
          housekeepingServiceType: "",
          interestInAutomatedDisinfection: false,
          customizationNeedsForScheduling: [],
          integrationWithSmartHomeSystem: false,
          concernsAboutUVCUsage: false,
        },
        smartHome: {
          existingSmartHomeSystem: false,
          preferredBrands: [],
          integrationNeeds: "",
        },
        demoNextSteps: {
          interestInOnSiteDemo: false,
          pilotProjectReadiness: false,
          keyDecisionMaker: "",
          expectedTimelineForDecisionMaking: [],
        },
        additionalnotes: {
          note: "",
        },
      });
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response?.data || error.message
      );
      alert(`Failed to submit home data: ${
          error.response?.data?.message || error.message
        }`);
    }
  };

  return (
    <div style={pageStyle}>
      <IconButton
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          color: "#4a4a4a",
          zIndex: 10,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <div style={{ textAlign: "center", marginTop: 20, marginBottom: 28 }}>
        <h1
          style={{
            margin: 0,
            marginBottom: 8,
            fontSize: "1.85rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Celebrity Home Form
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: "0.95rem",
            color: "#64748b",
            fontWeight: 400,
          }}
        >
          Complete the sections below. Use Previous and Next to move between steps.
        </p>
      </div>

      <div
        style={{
          maxWidth: 720,
          margin: "0 auto 20px",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        {FORM_STEPS.map((name, i) => (
          <span
            key={i}
            style={{
              padding: "6px 12px",
              borderRadius: 8,
              fontSize: "0.8rem",
              fontWeight: 500,
              background:
                currentStep === i
                  ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                  : "#e2e8f0",
              color: currentStep === i ? "#fff" : "#64748b",
            }}
          >
            {name}
          </span>
        ))}
      </div>

      <form onSubmit={handleSubmit}>
        <div style={cardStyle}>
          {currentStep === 0 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Home Info</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 1 of {totalSteps}
                </p>
              </div>
              {[
            { label: "Celebrity Name", name: "celebrityName", type: "text" },
            {
              label: "Home Type",
              name: "homeType",
              type: "select",
              options: [
                "Mansion",
                "Penthouse",
                "Villa",
                "Yacht",
                "Private Island",
              ],
            },
            {
              label: "Total Floor Area (sq. ft.)",
              name: "totalFloorArea",
              type: "number",
            },
            { label: "Total Floors", name: "totalFloors", type: "number" },
            { label: "Total Rooms", name: "totalRooms", type: "number" },
            {
              label: "Luxury Certifications",
              name: "luxuryCertifications",
              type: "text",
            },
          ].map(({ label, name, type, options }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              {type === "select" ? (
                <select
                  name={name}
                  value={formData.homeInfo[name] || ""}
                  onChange={(e) => handleChange(e, "homeInfo")}
                  style={inputStyle}
                >
                  <option value="">Select {label}</option>
                  {options.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={type}
                  name={name}
                  placeholder={
                    type === "number"
                      ? "Enter a number"
                      : "Enter " + label.toLowerCase()
                  }
                  value={formData.homeInfo[name] || ""}
                  onChange={(e) => {
                    const val =
                      type === "number"
                        ? Math.max(0, Number(e.target.value)) || 0
                        : e.target.value;
                    handleChange({ target: { name, value: val } }, "homeInfo");
                  }}
                  style={inputStyle}
                />
              )}
            </div>
          ))}
            </>
          )}

          {currentStep === 1 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Data Collection</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 2 of {totalSteps}
                </p>
              </div>
          {/* Date of Data Collection */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Date of Data Collection</label>
            <input
              type="date"
              name="dateOfDataCollection"
              value={formData.dataCollection.dateOfDataCollection || ""}
              onChange={(e) => handleChange(e, "dataCollection")}
              style={inputStyle}
            />
          </div>

          {/* Data Collected By (Input Field) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Data Collected By</label>
            <input
              type="text"
              name="dataCollectedBy"
              placeholder="Enter names separated by commas"
              value={formData.dataCollection.dataCollectedBy || ""}
              onChange={(e) => handleChange(e, "dataCollection")}
              style={inputStyle}
            />
          </div>

          {/* Data Source (Dropdown) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Data Source</label>
            <select
              name="dataSource"
              value={formData.dataCollection.dataSource || ""}
              onChange={(e) => handleChange(e, "dataCollection")}
              style={inputStyle}
            >
              <option value="">Select Data Source</option>
              {["Estate Manager", "Security", "Housekeeping"].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
            </>
          )}

          {currentStep === 2 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Home Layout</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 3 of {totalSteps}
                </p>
              </div>
          {/* Numeric Fields */}
          {[
            { label: "Bedrooms", name: "bedrooms", type: "number" },
            { label: "Bathrooms", name: "bathrooms", type: "number" },
            { label: "Guest Suites", name: "guestSuites", type: "number" },
            {
              label: "Walk-In Closet Count",
              name: "walkInClosetCount",
              type: "number",
            },
          ].map(({ label, name, type }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              <input
                type={type}
                name={name}
                placeholder="Enter a number"
                value={formData.homeLayout[name] || ""}
                onChange={(e) => {
                  const val = Math.max(0, Number(e.target.value)) || 0
                  handleChange({ target: { name, value: val } }, "homeLayout");
                }}
                style={inputStyle}
              />
            </div>
          ))}

          {/* Boolean Fields (Radio Buttons with True/False Options) */}
          {[
            { label: "Cinema Room", name: "cinemaRoom" },
            { label: "Private Gym", name: "privateGym" },
            { label: "Indoor Spa", name: "indoorSpa" },
            { label: "Home Office", name: "homeOffice" },
            { label: "Game Room", name: "gameRoom" },
            { label: "Wine Cellar", name: "wineCellar" },
          ].map(({ label, name }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              <div style={{ display: "flex", gap: "15px" }}>
                {/* True Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name={name}
                    value="true"
                    checked={formData.homeLayout[name] === true}
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        homeLayout: { ...prevData.homeLayout, [name]: true },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "green" }}>
                    True
                  </span>
                </label>

                {/* False Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name={name}
                    value="false"
                    checked={formData.homeLayout[name] === false}
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        homeLayout: { ...prevData.homeLayout, [name]: false },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "red" }}>
                    False
                  </span>
                </label>
              </div>
            </div>
          ))}

          {/* Outdoor Spaces (Dropdown) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Outdoor Spaces</label>
            <select
              name="outdoorSpaces"
              value={formData.homeLayout.outdoorSpaces || ""}
              onChange={(e) => handleChange(e, "homeLayout")}
              style={inputStyle}
            >
              <option value="">Select Outdoor Space</option>
              {["Pool", "Garden", "Tennis Court"].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
            </>
          )}

          {currentStep === 3 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Cleaning and Disinfect</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 4 of {totalSteps}
                </p>
              </div>
          {/* Numeric Fields */}
          {[
            {
              label: "Total Budget Per Month",
              name: "totalBudgetPerMonth",
              type: "number",
            },
            {
              label: "Cleaning Cost for Bedrooms (%)",
              name: "cleaningCostbedrooms",
              type: "number",
            },
            {
              label: "Cleaning Cost for Common Areas (%)",
              name: "cleaningCostcommonAreas",
              type: "number",
            },
            {
              label: "Cleaning Cost for Gym/Spa (%)",
              name: "cleaningCostgymSpa",
              type: "number",
            },
            {
              label: "Cleaning Cost for Entertainment Areas (%)",
              name: "cleaningCostentertainmentAreas",
              type: "number",
            },
            {
              label: "Cleaning Cost for Kitchen (%)",
              name: "cleaningCostkitchen",
              type: "number",
            },
            {
              label: "Disinfection Frequency Per Room Per Day",
              name: "disinfectionFrequencyPerRoomPerDay",
              type: "number",
            },
          ].map(({ label, name, type }) => (
            <div style={inputGroupStyle} key={name}>
              <label style={labelStyle}>{label}</label>
              <input
                type={type}
                name={name}
                placeholder="Enter a number"
                value={formData.cleaningDisinfect[name] || ""}
                onChange={(e) => {
                  const val = Math.max(0, Number(e.target.value)) || 0
                  handleChange(
                    { target: { name, value: val } },
                    "cleaningDisinfect"
                  );
                }}
                style={inputStyle}
              />
            </div>
          ))}

          {/* Current Disinfection Methods (Multi-select Checkboxes) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Current Disinfection Methods</label>
            {["Manual", "UV-C", "Chemical", "Other"].map((option) => (
              <div
                key={option}
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="checkbox"
                  name="currentDisinfectionMethods"
                  value={option}
                  checked={formData.cleaningDisinfect.currentDisinfectionMethods.includes(
                    option
                  )}
                  onChange={(e) => {
                    const { checked, value } = e.target;
                    setFormData((prevData) => ({
                      ...prevData,
                      cleaningDisinfect: {
                        ...prevData.cleaningDisinfect,
                        currentDisinfectionMethods: checked
                          ? [
                              ...prevData.cleaningDisinfect
                                .currentDisinfectionMethods,
                              value,
                            ]
                          : prevData.cleaningDisinfect.currentDisinfectionMethods.filter(
                              (item) => item !== value
                            ),
                      },
                    }));
                  }}
                  style={{ width: "20px", height: "20px", cursor: "pointer" }}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>

          {/* Challenges (Multi-select Checkboxes) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Challenges</label>
            {["High Cost", "Time-Consuming", "Chemical Residue", "Other"].map(
              (option) => (
                <div
                  key={option}
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <input
                    type="checkbox"
                    name="challenges"
                    value={option}
                    checked={formData.cleaningDisinfect.challenges.includes(
                      option
                    )}
                    onChange={(e) => {
                      const { checked, value } = e.target;
                      setFormData((prevData) => ({
                        ...prevData,
                        cleaningDisinfect: {
                          ...prevData.cleaningDisinfect,
                          challenges: checked
                            ? [...prevData.cleaningDisinfect.challenges, value]
                            : prevData.cleaningDisinfect.challenges.filter(
                                (item) => item !== value
                              ),
                        },
                      }));
                    }}
                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                  />
                  <label>{option}</label>
                </div>
              )
            )}
          </div>
            </>
          )}

          {currentStep === 4 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Privacy and Security</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 5 of {totalSteps}
                </p>
              </div>
          {/* Privacy Concern Level (Dropdown) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Privacy Concern Level</label>
            <select
              name="privacyConcernLevel"
              value={formData.privacySecurity.privacyConcernLevel || ""}
              onChange={(e) => handleChange(e, "privacySecurity")}
              style={inputStyle}
            >
              <option value="">Select Privacy Concern Level</option>
              {["Low", "Medium", "High"].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          {/* Security Clearance Required (Radio Buttons) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Security Clearance Required</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* True Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="securityClearanceRequired"
                  value="true"
                  checked={
                    formData.privacySecurity.securityClearanceRequired === true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      privacySecurity: {
                        ...prevData.privacySecurity,
                        securityClearanceRequired: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>True</span>
              </label>

              {/* False Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="securityClearanceRequired"
                  value="false"
                  checked={
                    formData.privacySecurity.securityClearanceRequired === false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      privacySecurity: {
                        ...prevData.privacySecurity,
                        securityClearanceRequired: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>False</span>
              </label>
            </div>
          </div>

          {/* Restricted Areas (Multi-select Checkboxes) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Restricted Areas</label>
            {["Bedrooms", "Home Office", "Gym", "Spa", "Other"].map(
              (option) => (
                <div
                  key={option}
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <input
                    type="checkbox"
                    name="restrictedAreas"
                    value={option}
                    checked={formData.privacySecurity.restrictedAreas.includes(
                      option
                    )}
                    onChange={(e) => {
                      const { checked, value } = e.target;
                      setFormData((prevData) => ({
                        ...prevData,
                        privacySecurity: {
                          ...prevData.privacySecurity,
                          restrictedAreas: checked
                            ? [
                                ...prevData.privacySecurity.restrictedAreas,
                                value,
                              ]
                            : prevData.privacySecurity.restrictedAreas.filter(
                                (item) => item !== value
                              ),
                        },
                      }));
                    }}
                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                  />
                  <label>{option}</label>
                </div>
              )
            )}
          </div>

          {/* AI Automation Privacy Concerns (Radio Buttons) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>AI Automation Privacy Concerns</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* True Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="aiAutomationPrivacyConcerns"
                  value="true"
                  checked={
                    formData.privacySecurity.aiAutomationPrivacyConcerns ===
                    true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      privacySecurity: {
                        ...prevData.privacySecurity,
                        aiAutomationPrivacyConcerns: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>True</span>
              </label>

              {/* False Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="aiAutomationPrivacyConcerns"
                  value="false"
                  checked={
                    formData.privacySecurity.aiAutomationPrivacyConcerns ===
                    false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      privacySecurity: {
                        ...prevData.privacySecurity,
                        aiAutomationPrivacyConcerns: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>False</span>
              </label>
            </div>
          </div>

          {/* Custom Security Integration Needs (Multi-select Checkboxes) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Custom Security Integration Needs
            </label>
            {["Surveillance", "Access Control", "Alarm Systems", "Other"].map(
              (option) => (
                <div
                  key={option}
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <input
                    type="checkbox"
                    name="customSecurityIntegrationNeeds"
                    value={option}
                    checked={formData.privacySecurity.customSecurityIntegrationNeeds.includes(
                      option
                    )}
                    onChange={(e) => {
                      const { checked, value } = e.target;
                      setFormData((prevData) => ({
                        ...prevData,
                        privacySecurity: {
                          ...prevData.privacySecurity,
                          customSecurityIntegrationNeeds: checked
                            ? [
                                ...prevData.privacySecurity
                                  .customSecurityIntegrationNeeds,
                                value,
                              ]
                            : prevData.privacySecurity.customSecurityIntegrationNeeds.filter(
                                (item) => item !== value
                              ),
                        },
                      }));
                    }}
                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                  />
                  <label>{option}</label>
                </div>
              )
            )}
          </div>
            </>
          )}

          {currentStep === 5 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Staff and Automation</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 6 of {totalSteps}
                </p>
              </div>

          {/* Number of Housekeeping Staff (Number Input) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Number of Housekeeping Staff</label>
            <input
              type="number"
              name="numberOfHousekeepingStaff"
              placeholder="Enter a number"
              value={formData.staffAutomation.numberOfHousekeepingStaff || ""}
              onChange={(e) => {
                const val = Math.max(0, Number(e.target.value)) || 0
                handleChange(
                  { target: { name: "numberOfHousekeepingStaff", value: val } },
                  "staffAutomation"
                );
              }}
              style={inputStyle}
            />
          </div>

          {/* Cleaning Staff Shift Hours (Multi-select Checkboxes) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Cleaning Staff Shift Hours</label>
            {["Morning", "Afternoon", "Evening", "Night"].map((option) => (
              <div
                key={option}
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="checkbox"
                  name="cleaningStaffShiftHours"
                  value={option}
                  checked={formData.staffAutomation.cleaningStaffShiftHours.includes(
                    option
                  )}
                  onChange={(e) => {
                    const { checked, value } = e.target;
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAutomation: {
                        ...prevData.staffAutomation,
                        cleaningStaffShiftHours: checked
                          ? [
                              ...prevData.staffAutomation
                                .cleaningStaffShiftHours,
                              value,
                            ]
                          : prevData.staffAutomation.cleaningStaffShiftHours.filter(
                              (item) => item !== value
                            ),
                      },
                    }));
                  }}
                  style={{ width: "20px", height: "20px", cursor: "pointer" }}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>

          {/* Housekeeping Service Type (Dropdown) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Housekeeping Service Type</label>
            <select
              name="housekeepingServiceType"
              value={formData.staffAutomation.housekeepingServiceType || ""}
              onChange={(e) => handleChange(e, "staffAutomation")}
              style={inputStyle}
            >
              <option value="">Select Service Type</option>
              {["Live-in", "Daily", "On-Call"].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          {/* Interest in Automated Disinfection (Radio Buttons) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Interest in Automated Disinfection
            </label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* True Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="interestInAutomatedDisinfection"
                  value="true"
                  checked={
                    formData.staffAutomation.interestInAutomatedDisinfection ===
                    true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAutomation: {
                        ...prevData.staffAutomation,
                        interestInAutomatedDisinfection: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* False Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="interestInAutomatedDisinfection"
                  value="false"
                  checked={
                    formData.staffAutomation.interestInAutomatedDisinfection ===
                    false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAutomation: {
                        ...prevData.staffAutomation,
                        interestInAutomatedDisinfection: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>

          {/* Customization Needs for Scheduling (Multi-select Checkboxes) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Customization Needs for Scheduling
            </label>
            {[
              "Flexible Hours",
              "Priority Areas",
              "Custom Cleaning Plans",
              "Other",
            ].map((option) => (
              <div
                key={option}
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="checkbox"
                  name="customizationNeedsForScheduling"
                  value={option}
                  checked={formData.staffAutomation.customizationNeedsForScheduling.includes(
                    option
                  )}
                  onChange={(e) => {
                    const { checked, value } = e.target;
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAutomation: {
                        ...prevData.staffAutomation,
                        customizationNeedsForScheduling: checked
                          ? [
                              ...prevData.staffAutomation
                                .customizationNeedsForScheduling,
                              value,
                            ]
                          : prevData.staffAutomation.customizationNeedsForScheduling.filter(
                              (item) => item !== value
                            ),
                      },
                    }));
                  }}
                  style={{ width: "20px", height: "20px", cursor: "pointer" }}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>

          {/* Integration with Smart Home System (Radio Buttons) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Integration with Smart Home System
            </label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* Yes Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="integrationWithSmartHomeSystem"
                  value="true"
                  checked={
                    formData.staffAutomation.integrationWithSmartHomeSystem ===
                    true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAutomation: {
                        ...prevData.staffAutomation,
                        integrationWithSmartHomeSystem: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* No Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="integrationWithSmartHomeSystem"
                  value="false"
                  checked={
                    formData.staffAutomation.integrationWithSmartHomeSystem ===
                    false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAutomation: {
                        ...prevData.staffAutomation,
                        integrationWithSmartHomeSystem: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>

          {/* Concerns About UVC Usage (Radio Buttons) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Concerns About UVC Usage</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* Yes Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="concernsAboutUVCUsage"
                  value="true"
                  checked={
                    formData.staffAutomation.concernsAboutUVCUsage === true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAutomation: {
                        ...prevData.staffAutomation,
                        concernsAboutUVCUsage: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* No Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="concernsAboutUVCUsage"
                  value="false"
                  checked={
                    formData.staffAutomation.concernsAboutUVCUsage === false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      staffAutomation: {
                        ...prevData.staffAutomation,
                        concernsAboutUVCUsage: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>
            </>
          )}

          {currentStep === 6 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Smart Home</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 7 of {totalSteps}
                </p>
              </div>
          {/* Existing Smart Home System (Radio Buttons) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Existing Smart Home System</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* Yes Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="existingSmartHomeSystem"
                  value="true"
                  checked={formData.smartHome.existingSmartHomeSystem === true}
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      smartHome: {
                        ...prevData.smartHome,
                        existingSmartHomeSystem: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* No Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="existingSmartHomeSystem"
                  value="false"
                  checked={formData.smartHome.existingSmartHomeSystem === false}
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      smartHome: {
                        ...prevData.smartHome,
                        existingSmartHomeSystem: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>

          {/* Preferred Brands (Input Type) */}

          <div style={inputGroupStyle}>
            <label style={labelStyle}>Preferred Brands</label>
            <input
              type="text"
              name="preferredBrands"
              placeholder="Enter preferred brands"
              value={formData.smartHome.preferredBrands || ""}
              onChange={(e) => handleChange(e, "smartHome")}
              style={inputStyle}
            />
          </div>

          {/* Integration Needs (Dropdown) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Integration Needs</label>
            <select
              name="integrationNeeds"
              value={formData.smartHome.integrationNeeds || ""}
              onChange={(e) => handleChange(e, "smartHome")}
              style={inputStyle}
            >
              <option value="">Select Integration Needs</option>
              {["App Control", "Voice Assistants", "Custom Scheduling"].map(
                (option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                )
              )}
            </select>
          </div>
            </>
          )}

          {currentStep === 7 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Demo and Next Steps</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 8 of {totalSteps}
                </p>
              </div>
          {/* Interest in On-Site Demo (Checkbox) */}
          <div style={inputGroupStyle}>
            {/* Interest in On-Site Demo (Radio Buttons) */}
            <div style={inputGroupStyle}>
              <label style={labelStyle}>Interest in On-Site Demo</label>
              <div style={{ display: "flex", gap: "15px" }}>
                {/* Yes Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name="interestInOnSiteDemo"
                    value="true"
                    checked={
                      formData.demoNextSteps.interestInOnSiteDemo === true
                    }
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        demoNextSteps: {
                          ...prevData.demoNextSteps,
                          interestInOnSiteDemo: true,
                        },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "green" }}>
                    Yes
                  </span>
                </label>

                {/* No Option */}
                <label
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <input
                    type="radio"
                    name="interestInOnSiteDemo"
                    value="false"
                    checked={
                      formData.demoNextSteps.interestInOnSiteDemo === false
                    }
                    onChange={() =>
                      setFormData((prevData) => ({
                        ...prevData,
                        demoNextSteps: {
                          ...prevData.demoNextSteps,
                          interestInOnSiteDemo: false,
                        },
                      }))
                    }
                    style={{ width: "18px", height: "18px", cursor: "pointer" }}
                  />
                  <span style={{ fontWeight: "bold", color: "red" }}>No</span>
                </label>
              </div>
            </div>
          </div>

          {/* Pilot Project Readiness (Radio Buttons) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Pilot Project Readiness</label>
            <div style={{ display: "flex", gap: "15px" }}>
              {/* Yes Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="pilotProjectReadiness"
                  value="true"
                  checked={
                    formData.demoNextSteps.pilotProjectReadiness === true
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      demoNextSteps: {
                        ...prevData.demoNextSteps,
                        pilotProjectReadiness: true,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "green" }}>Yes</span>
              </label>

              {/* No Option */}
              <label
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                <input
                  type="radio"
                  name="pilotProjectReadiness"
                  value="false"
                  checked={
                    formData.demoNextSteps.pilotProjectReadiness === false
                  }
                  onChange={() =>
                    setFormData((prevData) => ({
                      ...prevData,
                      demoNextSteps: {
                        ...prevData.demoNextSteps,
                        pilotProjectReadiness: false,
                      },
                    }))
                  }
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: "bold", color: "red" }}>No</span>
              </label>
            </div>
          </div>

          {/* Key Decision Maker (Dropdown) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Key Decision Maker</label>
            <select
              name="keyDecisionMaker"
              value={formData.demoNextSteps.keyDecisionMaker || ""}
              onChange={(e) => handleChange(e, "demoNextSteps")}
              style={inputStyle}
            >
              <option value="">Select Key Decision Maker</option>
              {["Estate Manager", "Personal Assistant", "Celebrity"].map(
                (option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                )
              )}
            </select>
          </div>

          {/* Expected Timeline for Decision Making (Multi-select Checkboxes) */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>
              Expected Timeline for Decision Making
            </label>
            {["1-2 Weeks", "1 Month", "3 Months", "6 Months", "Other"].map(
              (option) => (
                <div
                  key={option}
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <input
                    type="checkbox"
                    name="expectedTimelineForDecisionMaking"
                    value={option}
                    checked={formData.demoNextSteps.expectedTimelineForDecisionMaking.includes(
                      option
                    )}
                    onChange={(e) => {
                      const { checked, value } = e.target;
                      setFormData((prevData) => ({
                        ...prevData,
                        demoNextSteps: {
                          ...prevData.demoNextSteps,
                          expectedTimelineForDecisionMaking: checked
                            ? [
                                ...prevData.demoNextSteps
                                  .expectedTimelineForDecisionMaking,
                                value,
                              ]
                            : prevData.demoNextSteps.expectedTimelineForDecisionMaking.filter(
                                (item) => item !== value
                              ),
                        },
                      }));
                    }}
                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                  />
                  <label>{option}</label>
                </div>
              )
            )}
          </div>
            </>
          )}

          {currentStep === 8 && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 20,
                }}
              >
                <h3 style={sectionTitleStyle}>Additional Notes</h3>
                <p
                  style={{
                    margin: 0,
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Step 9 of {totalSteps}
                </p>
              </div>
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Notes</label>
            <textarea
              name="note"
              value={formData.additionalnotes.note}
              onChange={(e) => handleChange(e, "additionalnotes")}
              style={{
                width: "100%",
                minHeight: 120,
                padding: "0.65rem 0.85rem",
                borderRadius: 8,
                border: "1px solid #e2e8f0",
                fontSize: "1rem",
                outline: "none",
                boxSizing: "border-box",
                resize: "vertical",
              }}
              placeholder="Enter any additional notes here..."
            />
          </div>
            </>
          )}
        </div>

        <div
          style={{
            maxWidth: 720,
            margin: "0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent:
              currentStep === 0 ? "flex-end" : "space-between",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          {currentStep > 0 ? (
            <button
              type="button"
              onClick={() => setCurrentStep((s) => s - 1)}
              style={{
                padding: "0.65rem 1.25rem",
                fontSize: "1rem",
                fontWeight: 600,
                color: "#64748b",
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
              }}
            >
              Previous
            </button>
          ) : (
            <span />
          )}
          {currentStep < totalSteps - 1 ? (
            <button
              type="button"
              onClick={() => setCurrentStep((s) => s + 1)}
              style={{
                padding: "0.65rem 1.25rem",
                fontSize: "1rem",
                fontWeight: 600,
                background:
                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
              }}
            >
              Next
            </button>
          ) : (
            <button
              type="submit"
              style={{
                padding: "0.65rem 1.25rem",
                fontSize: "1rem",
                fontWeight: 600,
                background:
                  "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
              }}
            >
              Submit
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default CelebrityHome;
